import React               from 'react';
import { withRouter }      from 'react-router';
import { connect }         from 'react-redux';
import { FormControl }     from 'react-bootstrap';
import { Button }          from 'react-bootstrap';
import { Alert }           from 'react-bootstrap';
import CatalogBreadcrumb   from '../catalog/Breadcrumb';
import { PubSubConstants } from './environment';
import { tokenFetchData }  from '../../../actions/password/token';

var apiHost = PubSubConstants.WebApiHost;

class PasswordReset extends React.Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Password Reset';
  }
    
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: ''
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleClick  = this.handleClick.bind(this);
  }
  
  handleChange(e) {
    this.setState({ value: e.target.value });
  }
  
  handleClick(e) {
    this.props.fetchData(apiHost, this.state.value);
  }

  render() {
    return (
      <div>
        <CatalogBreadcrumb {...this.props} />
        <div className={'input-group'}>
          <FormControl  
            type='text'
            value={this.state.value} 
            placeholder='Please enter your Boise State username'
            onChange={this.handleChange} 
          />
          <span className={'input-group-btn'}>
            <Button bsStyle='primary' onClick={this.handleClick}>
              Request Token
            </Button>
          </span>
        </div>
        { this.props.token ?
          <Alert bsStyle='success'>
            <strong>Success!</strong> Please call {this.props.token.phone} with code {this.props.token.token}
          </Alert>
        :
          <span />
        }          
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.password.token.token,
    hasErrored: state.password.token.tokenHasErrored,
    isLoading: state.password.token.tokenIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(tokenFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));
